import { CSSProperties } from "@material-ui/core/styles/withStyles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { theme, greys, colors } from "@clockwise/web-commons/src/styles/color.styles";
import { size, weight } from "@clockwise/web-commons/src/styles/type.styles";

export const container: CSSProperties = {
  paddingTop: spacing.std,
};

export const containerBordered: CSSProperties = {
  ...container,
  background: greys.white,
  borderStyle: "solid",
  borderColor: greys.borderGrey,
  borderWidth: 1,

  "@media (max-width: 768px)": {
    borderStyle: "none",
  },
};

export const chromeContainer: CSSProperties = {};

export const divider: CSSProperties = {
  backgroundColor: greys.palePaleGrey,
  height: 12,
};

export const section: CSSProperties = {
  padding: "15px 5px 15px 15px",
};

export const cardContent: CSSProperties = {
  padding: spacing.sm,
};

export const cardHeader: CSSProperties = {
  paddingBottom: 10,
  lineHeight: 1.4,
  textAlign: "center",
};

export const cardBody: CSSProperties = {
  fontSize: 14,
  color: theme.textSecondary,
  lineHeight: 1.4,
};

export const btnStyle: CSSProperties = {
  background: greys.paleGrey,
};

export const btnLabel: CSSProperties = {
  fontSize: size.sm,
};

export const confirmation = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    fontSize: size.md,
    color: greys.slate,
  } as CSSProperties,
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  } as CSSProperties,
  check: {
    htmlColor: colors.green.standard,
    style: {
      marginRight: spacing.sm,
    } as CSSProperties,
  },
  h2: {
    color: colors.blueDusk.standard,
    marginBottom: 0,
    flexGrow: 1,
  } as CSSProperties,
};

export const icon = {
  htmlColor: greys.slate,
};

export const sectionIcon = {
  color: colors.blueDusk.standard,
  width: 20,
  height: 20,
  flexShrink: 0,
  verticalAlign: "top",
  marginRight: 4,
};

export const close: CSSProperties = {
  ...icon,
  alignSelf: "flex-end",
};

export const autopilotList = {
  style: {
    marginTop: 5,
  } as CSSProperties,
  labelStyle: {
    color: greys.slate,
  } as CSSProperties,
};

export const threadInfo = {
  container: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
    cursor: "pointer",
  } as CSSProperties,
  icon: {
    style: {
      width: 18,
      height: 18,
      marginRight: 10,
    } as CSSProperties,
    htmlColor: colors.blueDusk.darker,
  },
  topic: {
    fontSize: 12,
    color: colors.blueDusk.darker,
    fontWeight: weight.bold,
    borderBottom: `1px dashed ${colors.blueDusk.darker}`,
  } as CSSProperties,
};

export const loadingContainer = {
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: `${spacing.std}px 0 ${spacing.xlg}px`,
} as CSSProperties;

export const styles = {
  container,
  containerBordered,
  chromeContainer,
};
